import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import { idZodSchema } from "@@/shared/id";
import { providerIdZodSchema } from "@@/shared/providers/provider-id";
import { generateId } from "@@/utilities/generate-id";
import { z } from "zod";
import { agendaPresetIdZodSchema } from "./agenda-preset-id";

const agendaPresetRemoveCommandZodObject = z.object({
    _id: idZodSchema,
    _type: z.literal("AGENDA_PRESET_REMOVE_COMMAND"),
    _createdAt: isoAndUnixZodSchema,
    agendaPresetId: agendaPresetIdZodSchema,
    providerId: providerIdZodSchema,
});

type AgendaPresetRemoveCommand = z.infer<
    typeof agendaPresetRemoveCommandZodObject
>;

const agendaPresetRemoveCommandFactoryParamsZodObject =
    agendaPresetRemoveCommandZodObject.omit({
        _id: true,
        _type: true,
        _createdAt: true,
    });
type FactoryParams = z.infer<
    typeof agendaPresetRemoveCommandFactoryParamsZodObject
>;

const agendaPresetRemoveCommandFactory = (params: FactoryParams) => {
    const agendaPresetRemoveCommand: AgendaPresetRemoveCommand = {
        ...params,
        _id: generateId({ prefix: "agenda_preset_add_command__" }),
        _type: "AGENDA_PRESET_REMOVE_COMMAND",
        _createdAt: nowIsoAndUnix(),
    };
    return agendaPresetRemoveCommand;
};

export {
    agendaPresetRemoveCommandFactory,
    agendaPresetRemoveCommandFactoryParamsZodObject,
    agendaPresetRemoveCommandZodObject,
};
export type {
    AgendaPresetRemoveCommand,
    FactoryParams as AgendaPresetRemoveCommandFactoryParams,
};
